import { css } from '@emotion/css'
import { breakpoint, colors, hexToRgba, mediaQueryHelper, shorthandHelper, spacing } from '@offerzen/pinata-shame'

const APPLICATION_CARD_WIDTH = 300

const styles = {
  mobileSpacingWrapper: css({
    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      padding: shorthandHelper([spacing.default]),
    },
  }),

  jobDetails: css({
    flexDirection: 'column',
  }),

  container: css({
    [mediaQueryHelper(breakpoint.tablet)]: {
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gap: spacing.medium,
    },
  }),

  applicationCardTablet: ({ topOffset }) =>
    css({
      position: 'sticky',
      top: (topOffset || 0) + spacing.default,
      width: APPLICATION_CARD_WIDTH,
    }),

  applicationCardMobile: css({
    display: 'block',
    border: `1px solid ${colors.mystic}`,
    boxShadow: `1px 1px 5px  ${hexToRgba(colors.black, 0.1)}`,
  }),

  mobileApplyButton: css({
    paddingLeft: spacing.default,
    paddingRight: spacing.default,
    marginBottom: spacing.large,

    button: {
      [mediaQueryHelper(breakpoint.phone, 'max-width')]: {
        width: '100%',
      },
    },
  }),
}

export default styles
